export const radarOptions = {
  radar: {
    axes: {
      angle: 'feature',
      value: 'score',
    },
  },
  data: {
    groupMapsTo: 'product',
  },
  toolbar: { enabled: false },
  height: '400px',
  color: {
    scale: { Ideal: '#d4bbff', User: '#3edbd9' },
  },
};

// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30N9J = '30C9R';

/* Start of Modal Form data */
export const productTitle = 'Cyber Resilience Assessment';
export const pageUrl = '/products/cyber-resilience-assessment';
export const pageTitle = 'Cyber Resilience Assessment';
export const object = 'Cyber Resilience Assessment Page';
export const location = 'CRA Form';
export const btnExport = 'Download PDF';

/* End */
export const apiUrl = (locale: string) => {
  return `https://stft-api-stage.5a8cbfd1.public.multi-containers.ibm.com/flashsystem/pricing/api/locales/${locale}/storefront?type=questions&refresh_redis=true`;
};
export const AWS_SALES =
  'https://aws.amazon.com/marketplace/pp/prodview-zw7rst7t566c2?sr=0-6&ref_=beagle&applicationId=AWSMPContessa';

export const SKELETON_IMAGE =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAQAAADYv8WvAAAAEElEQVR42mN8+p+BgRFEAAAWrwPLzYNPyAAAAABJRU5ErkJggg==';
